import {
  TABBED_TOOLBAR_SET_ACTIVE_TAB,
  TABBED_TOOLBAR_SET_TABS,
} from '../TabbedToolbarConstants';

export const DEFAULT_STATE = -1;

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case TABBED_TOOLBAR_SET_ACTIVE_TAB:
      return action.index;
    case TABBED_TOOLBAR_SET_TABS:
      return action.tabs.length === 0 ? null : 0;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src-react/TabbedToolbar/reducer/activeTab.js